// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"110":"8d24ea600b6bd913","418":"916b678fe16d3ea8","766":"05a327fbb44a7384"}[chunkId] + ".js";
};